import firebase from 'firebase'
import _ from 'lodash'
import { getToken, getQuantity } from '../helpers'

const state = {
  book: null,
  books: null,
  maxBook: null,
  errorBooks: null
}

const mutations = {
  setBook (state, payload) {
    state.book = payload
  },
  setBooks (state, payload) {
    state.books = payload
  },
  setMaxBook (state, payload) {
    state.maxBook = payload
  },
  setErrorBooks (state, payload) {
    state.errorBooks = payload
  }
}

const actions = {
  addBook ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser && payload.data) {
      firebase.database().ref('books').push().set(payload.data)
    }
  },
  updateBook ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser && payload.name && payload.key) {
      firebase.database().ref('books').child(payload.key).update({
        name: payload.name,
        updated_at: new Date().toISOString()
      })
    }
  },
  deleteBook ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser) {
      if (payload !== undefined && payload.key && payload.bookId) {
        let promiseCoins = firebase.database().ref('coins').orderByChild('book').equalTo(payload.bookId).once('value')
        let promiseBanknotes = firebase.database().ref('banknotes').orderByChild('book').equalTo(payload.bookId).once('value')
        let promiseBook = firebase.database().ref('books').child(payload.key).once('value')

        Promise.all([promiseCoins, promiseBanknotes, promiseBook]).then(data => {
          let coins = data[0]
          let banknotes = data[1]
          let book = data[2]
          if (coins) {
            coins.forEach(coin => coin.ref.remove())
          }
          if (banknotes) {
            banknotes.forEach(banknote => banknote.ref.remove())
          }
          if (book) {
            book.ref.remove()
          }
          window.location.href = '/books'
        })
      }
    }
  },
  fetchBook ({commit}, payload) {
    commit('setBook', null)
    let tokenUser = getToken()
    if (tokenUser) {
      if (payload !== undefined && payload.key) {
        let promiseBook = firebase.database().ref('books').child(payload.key).once('value')
        let promiseCoins = firebase.database().ref('coins').once('value')
        let promiseBanknotes = firebase.database().ref('banknotes').once('value')

        Promise.all([promiseBook, promiseCoins, promiseBanknotes]).then(data => {
          let book = data[0] ? data[0].val() : null
          let coins = data[1] ? data[1].val() : null
          let banknotes = data[2] ? data[2].val() : null

          let arrCoins = coins ? Object.entries(coins).map(([key, value]) => ({key, ...value})) : []
          let arrBanknotes = banknotes ? Object.entries(banknotes).map(([key, value]) => ({key, ...value})) : []

          if (book) {
            book.coins = arrCoins.filter(coin => coin.book === book.id)
            book.nbCoins = getQuantity(book.coins)
            book.banknotes = arrBanknotes.filter(banknote => banknote.book === book.id)
            book.nbBanknotes = getQuantity(book.banknotes)
            commit('setBook', book)
          }
        })
      }
    }
  },
  fetchBooks ({commit}) {
    commit('setBooks', null)
    let tokenUser = getToken()
    if (tokenUser) {
      let promiseBooks = firebase.database().ref('books').orderByChild('uid').equalTo(tokenUser).once('value')
      let promiseCoins = firebase.database().ref('coins').once('value')
      let promiseBanknotes = firebase.database().ref('banknotes').once('value')

      Promise.all([promiseBooks, promiseCoins, promiseBanknotes]).then(data => {
        let books = data[0] ? data[0].val() : null
        let coins = data[1] ? data[1].val() : null
        let banknotes = data[2] ? data[2].val() : null

        let arrBooks = books ? Object.entries(books).map(([key, value]) => ({key, ...value})) : []
        let arrCoins = coins ? Object.entries(coins).map(([key, value]) => ({key, ...value})) : []
        let arrBanknotes = banknotes ? Object.entries(banknotes).map(([key, value]) => ({key, ...value})) : []

        for (let i in arrBooks) {
          arrBooks[i].coins = arrBooks.length > 0 ? arrCoins.filter(coin => coin.book === arrBooks[i].id) : []
          arrBooks[i].nbCoins = arrBooks[i].coins.length > 0 ? getQuantity(arrBooks[i].coins) : 0
          arrBooks[i].banknotes = arrBooks.length > 0 ? arrBanknotes.filter(banknote => banknote.book === arrBooks[i].id) : []
          arrBooks[i].nbBanknotes = arrBooks[i].banknotes.length > 0 ? getQuantity(arrBooks[i].banknotes) : 0
        }
        commit('setBooks', arrBooks)
      })
    }
  },
  fetchMaxBook ({commit}) {
    commit('setMaxBook', null)
    let tokenUser = getToken()
    if (tokenUser) {
      firebase.database().ref('books').once('value').then(snapshot => {
        let books = snapshot.val()
        let arrBooks = Object.entries(books).map(([key, value]) => ({key, ...value}))
        let maxBook = null
        if (arrBooks.length > 0) {
          maxBook = _.maxBy(arrBooks, 'id')
        }
        commit('setMaxBook', maxBook)
      })
    }
  }
}

const getters = {
  book (state) {
    return state.book
  },
  books (state) {
    return state.books
  },
  maxBook (state) {
    return state.maxBook
  },
  errorBooks (state) {
    return state.errorBooks
  }
}

export default {
  namespaces: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/book.js